import http from './http.service';

class CertificateService {
    constructor() {
        this.$http = http;
        this.baseUrl = "http://127.0.0.1:5339/api/certificate";
    }

    signXml(xml) {
        const model = {
            xml: xml
        };

        return this.$http.post(`${this.baseUrl}/sign`, model);
    }
}

export default new CertificateService();
